import { FC } from "react"
import type { ErrorSchema, FieldProps } from "@rjsf/core"
import { JSONSchema7 } from "json-schema"
import { CommonParameter } from "./CommonParameter"

export const FieldDataParameter: FC<FieldProps> = ({
    formData,
    registry,
    idSchema,
    onChange,
    errorSchema,
    uiSchema,
    required,
    schema,
    disabled,
    ...rest
}) => {
    const SchemaField = registry.fields.SchemaField

    const handleChange = (e: any, es?: ErrorSchema | undefined) => {
        onChange({
            ...formData,
            data: !e && typeof e === "string" ? undefined : e
        })
    }

    return (
        <CommonParameter
            title={schema?.title?.trim()}
            description={schema.description}
            required={required}
        >
            <SchemaField
                {...rest}
                registry={registry}
                required={required}
                errorSchema={errorSchema?.data}
                uiSchema={uiSchema.data}
                idSchema={idSchema.data}
                formData={formData.data}
                onChange={handleChange}
                disabled={!formData.editable}
                schema={schema.properties?.data as JSONSchema7}
            />
        </CommonParameter>
    )
}
